module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_family@3x-ca08d7485966b741a9c16a991bd4763f.webp";